module.exports = __webpack_public_path__ + "img/img-registration-four@3x.861faf02.png";